import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";
import RenderCookieBanner from "vagaro-website-rendering/src/components/ComponentRenders/RenderCookieBanner";


export default class CookieBanner extends WBComponent {

    constructor(){
        super();
        this.typename = wBComponentTypeNames.cookieBanner;
        this.displayName = "Cookie Banner";
        this.dropList = [];
        this.primaryEditAttributes= ["cookieBannerOn","cookieBannerColorSetting","cbConditionalTxtStyle","cbConditionalTxtColor","cbConditionalBtnStyle","cbConditionalBgColor" ,"cookieBannerText",];
        this.editList =  [...this.primaryEditAttributes,"cookieBannerTextStyle","cookieBannerTxtColor","cookieBannerBtnStyle","cookieBannerBgColor"];
        this.contentEditable = false;
        this.hideAdvancedSettings = true;
    
        
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

        const bannerOn = new AttributeDefinition("cookieBannerOn","","",AttributeInputType.ButtonField,[{label:"Enable",value:""},{label:"Disable",value:"off"}]);
        const colorSetting = new AttributeDefinition("cookieBannerColorSetting","Color","",AttributeInputType.ButtonField,[{label:"Dark",value:""},{label:"Light",value:"light"},{label:"Custom",value:"custom"}]);
        const txtInput = new AttributeDefinition("cookieBannerText","Text","",AttributeInputType.EmojiField);

        const paragrahStyle = new AttributeDefinition("cookieBannerTextStyle","Text Style","",AttributeInputType.SelectField,[{label:"Paragraph 1",value:""},{label:"Paragraph 2",value:"vp-2"},{label:"Paragraph 3",value:"vp-3"}]);
        const conditionalpaaragraphStyle  = CreateConditionalAttribute("cbConditionalTxtStyle","cookieBannerTextStyle",[{key:"cookieBannerColorSetting",value:"custom"}]);
        
        const txtColor = new AttributeDefinition("cookieBannerTxtColor","Text Color","",AttributeInputType.ColorField);
        const conditionalTxtColor  = CreateConditionalAttribute("cbConditionalTxtColor","cookieBannerTxtColor",[{key:"cookieBannerColorSetting",value:"custom"}]);

        const btnStyle = new AttributeDefinition("cookieBannerBtnStyle","Button Style","",AttributeInputType.SelectField,[{label:"Primary",value:""},{label:"Secondary",value:"secondary"},{label:"Tertiary",value:"tertiary"}]);
        const conditionalBtnStyle  = CreateConditionalAttribute("cbConditionalBtnStyle","cookieBannerBtnStyle",[{key:"cookieBannerColorSetting",value:"custom"}]);
        
        const bgColor = new AttributeDefinition("cookieBannerBgColor","Background Color","",AttributeInputType.ColorField);
        const conditionalBgColor  = CreateConditionalAttribute("cbConditionalBgColor","cookieBannerBgColor",[{key:"cookieBannerColorSetting",value:"custom"}]);

        txtInput.placeHolder = "Cookie Policy.. "
        return [bannerOn,colorSetting,txtInput,
        
            paragrahStyle,conditionalpaaragraphStyle,
            txtColor,conditionalTxtColor,
            btnStyle,conditionalBtnStyle,
            bgColor,conditionalBgColor
        
        ];
    
    }

    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps)
     {

        return (


           <RenderCookieBanner node = {component}/>
        )

    }

}